/* tslint:disable */
/* eslint-disable */
/**
 * Remaster API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface DocumentPublic
 */
export interface DocumentPublic {
  /**
   *
   * @type {number}
   * @memberof DocumentPublic
   */
  readonly id: number
  /**
   *
   * @type {string}
   * @memberof DocumentPublic
   */
  slug?: string | null
  /**
   *
   * @type {string}
   * @memberof DocumentPublic
   */
  name?: string | null
  /**
   *
   * @type {string}
   * @memberof DocumentPublic
   */
  text?: string | null
}

/**
 * Check if a given object implements the DocumentPublic interface.
 */
export function instanceOfDocumentPublic(value: object): boolean {
  let isInstance = true
  isInstance = isInstance && 'id' in value

  return isInstance
}

export function DocumentPublicFromJSON(json: any): DocumentPublic {
  return DocumentPublicFromJSONTyped(json, false)
}

export function DocumentPublicFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): DocumentPublic {
  if (json === undefined || json === null) {
    return json
  }
  return {
    id: json['id'],
    slug: !exists(json, 'slug') ? undefined : json['slug'],
    name: !exists(json, 'name') ? undefined : json['name'],
    text: !exists(json, 'text') ? undefined : json['text'],
  }
}

export function DocumentPublicToJSON(value?: DocumentPublic | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    slug: value.slug,
    name: value.name,
    text: value.text,
  }
}
